//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            doctorid: this.$route.query.doctorid,
            inquireIncome: [],
            isCheck: false
        }
    },
    //挂载完成
    methods: {
        getCashList(){
            let params = {
                parameters: this.doctorid
            }
            this.$doRequest("api/AppHomePage/inquireIncomeList", params,res => {
                for(let i=0; i<res.inquireIncome.length; i++){
                    let year = res.inquireIncome[i].ctime.substring(0,4);
                    let month = res.inquireIncome[i].ctime.substring(res.inquireIncome[i].ctime.length-2);
                    this.inquireIncome.push({
                        ctime: year+'年'+month+'月',
                        money: res.inquireIncome[i].money
                    })
                }
            });
        },
        //查看税法规定
        check(){
            if(this.isCheck){
                this.isCheck = false;
            }else{
                this.isCheck = true;
            }
        }
    },
    //生命周期之创建完成
    created: function() {
        console.log(this.inquireIncome);
        this.getCashList();
        document.title = '收入及缴税详情';
    }
}



// WEBPACK FOOTER //
// ./src/views/rule/index.vue